"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isWithPlayerIdOptions_1 = __importDefault(require("./isWithPlayerIdOptions"));
function getFallbackPlayerName(id, t, optionsSpec) {
    if (optionsSpec && (0, isWithPlayerIdOptions_1.default)(optionsSpec)) {
        return optionsSpec.players.id.valueSpec(id).label(t);
    }
    else {
        return t('Player {number}', { number: id });
    }
}
exports.default = getFallbackPlayerName;
